import axios from 'axios';

import type Config from '../config/config';

const config: Partial<typeof Config> = {};

export const getConfig = () =>
  axios.get('/config').then((response) => {
    Object.assign(config, response.data);
    return config;
  });

export default config;
